<template>
<v-app>
    <v-container fill-height>
        <v-row justify="center">
            <v-col cols="6">
                <v-card id="rounded-card" height="100%" :elevation="elevation">
                    <v-row justify="center">
                            <v-img contain style="padding-top:40px" height="200px" width="100%" :src="require('../assets/12.png')" /><br />
                        </v-row>

                    <v-flex xs10 md10 offset-xs1 style="padding-top:2%">
                        <h2 style="text-align:center">ลืมรหัสผ่าน</h2>
                        <!-- <b>
                            <p style="text-indent: 30px; padding-left:5%" class="red--text">กรุณากรอกอีเมลล์เพื่อทำการรีเซ็ตรหัสผ่าน</p>
                        </b> -->
                    </v-flex>
                    <v-flex xs10 md10 offset-xs1 style="padding-top:2%">

                        <v-text-field filled label="กรุณากรอกอีเมลล์" prepend-inner-icon="mdi-email" style="border-radius:40px" outlined dense></v-text-field>
                    </v-flex>
                    
                        <div class="text-center" style="padding-bottom:2%">
                            <v-btn class="box" width="50%" rounded dark dense style="height:45px; font-size:20px" @click.stop="dialog = true">SUBMIT</v-btn>

                            <v-dialog v-model="dialog" max-width="290">
                                <v-card>
                                    <v-card-title >รีเซ็ตรหัสผ่าน</v-card-title>

                                    <v-card-text>กรุณาตรวจสอบอีเมลล์เพื่อรีเซ็ตรหัสผ่าน</v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>

                                        <v-btn color="primary darken-1" text @click="action('Login')">SUBMIT</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                      </div>

                        <!-- <v-col cols="4" @click="action('Login')">
                            <v-btn color style="border-radius: 10px;" depressed width="100%" outlined>CANCLE</v-btn>
                        </v-col> -->
                    
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</v-app>
</template>

<script>
import {
    Data
} from '../models'
import {
    mapState,
    dispatch,
    mapActions,
    store
} from 'vuex'

export default {
    data: () => ({
        username: null,
        password: null,
        elevation: 2,
        dialog: false,
    }),
    computed: {
        ...mapState('datas', {
            data: 'data'
        }),
        formlogin() {
            return (
                this.username &&
                this.password
            )
        }
    },
    methods: {
        login() {
            this.$router.push({
                name: 'Home'
            });
        },
        action(page) {
            this.$router.push({
                name: page
            });
        },
    }

}
</script>

<style>
/* .rounded-card{
    border-radius: 10px;
} */
#rounded-card {
    border-radius: 20px;
    -webkit-box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
    box-shadow: 0 -1px 10px rgba(0, 0, 0, 0.2) !important;
}

/* #footer_card {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    -webkit-box-shadow: 0 20px 50px rgba(0, 0, 0, .2);
    box-shadow: 0 -1px 5px rgba(0, 0, 0, .2);
} */
</style>
